// extracted by mini-css-extract-plugin
export var checkbox = "_84-0";
export var circle = "_84-3";
export var horizontalContainer = "_84-7";
export var sm = "_84-5";
export var switch0 = "_84-2";
export var switchDisabled = "_84-8";
export var switchEnabled = "_84-1";
export var textSwitchContainer = "_84-9";
export var textSwitchOption = "_84-a";
export var textSwitchOptionSelected = "_84-b";
export var verticalContainer = "_84-6";
export var xs = "_84-4";